import { FC } from 'react';
import { Button } from './styles';
import { ButtonToggleProps } from './types';

export const ButtonToggle: FC<ButtonToggleProps> = ({
	children,
	onClick,
	isChecked = false,
}) => {
	return (
		<Button role="button-toggle" onClick={!window.matchMedia("(pointer: coarse)").matches ? onClick : undefined} onTouchStart={onClick} $isChecked={isChecked}>
			{children}
		</Button>
	);
};
